import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

function TitleBox({ title, subject, windowSize }) {
  return (
    <div className="title-box">
      {windowSize > 576 && <p className='title'>{title}</p>}
      <p className='subject'>{subject}</p>
    </div>
  );
}

TitleBox.propTypes = {
  title: PropTypes.string.isRequired,
  subject: PropTypes.string,
  windowSize: PropTypes.number.isRequired,
};

const mapStateToProps = (state) => ({
  windowSize: state.themeReducer.windowSize,
});

export default connect(mapStateToProps)(TitleBox);
